import PartosWorkspace from '../../features/births/layouts/partos';

// TSS vite/01 §"Pages are thin".
export default function PartosPage() {
    return <PartosWorkspace />;
}
